export default __webpack_public_path__ + "static/media/tax.ab9e1dc0.webp";